module.exports = __webpack_public_path__ + "img/case23.93c8c03d.png";